import React, { useEffect, useState } from 'react';
import './Toast.css';

const Toast = ({ 
  message, 
  type = 'success', 
  duration = 4000, 
  isVisible, 
  onClose,
  details = null 
}) => {
  const [isShowing, setIsShowing] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setIsShowing(true);
      const timer = setTimeout(() => {
        setIsShowing(false);
        setTimeout(() => {
          onClose && onClose();
        }, 300); // Wait for animation to complete
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);

  if (!isVisible) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return '✅';
      case 'error':
        return '❌';
      case 'warning':
        return '⚠️';
      case 'info':
        return 'ℹ️';
      default:
        return '✅';
    }
  };

  const handleClose = () => {
    setIsShowing(false);
    setTimeout(() => {
      onClose && onClose();
    }, 300);
  };

  return (
    <div className={`toast toast-${type} ${isShowing ? 'toast-show' : 'toast-hide'}`}>
      <div className="toast-content">
        <div className="toast-header">
          <span className="toast-icon">{getIcon()}</span>
          <span className="toast-message">{message}</span>
          <button className="toast-close" onClick={handleClose}>×</button>
        </div>
        {details && (
          <div className="toast-details">
            {details}
          </div>
        )}
      </div>
    </div>
  );
};

export default Toast;